import { Component, OnInit } from '@angular/core';
import { ApiService } from '@app/utility/api.service'
import { UtilService } from '@app/utility/util.service'
import { environment } from '@env/environment';

declare var $: any, moment: any

@Component({
  selector: 'app-knowledge-base',
  templateUrl: './knowledge-base.component.html',
  styleUrls: ['./knowledge-base.component.scss']
})
export class KnowledgeBaseComponent implements OnInit {

  public Search: string = null;
  knowledgeList: any
  showingKBList: any = []
  keyword: string

  Ticket: any
  Editable = true

  searchType = "k"
  
  AcceptExtension: any;

  isCrisis: boolean = false
  config: any = {}

  categoryList: any = []

  submittedKB = false
  createType = ""
  createTitle = ""
  createKeyword = ""
  createContent = ""

  role: any = {}
  cookieData: any

  FileList: any = [];
  MaxTotalSizeMB: number

  constructor(
    private util: UtilService,
    private apiService: ApiService
  ) {
  }

  async ngOnInit() {
    const thisTs = this
    this.util.ShowWaiting(true)

    this.cookieData = JSON.parse(localStorage.getItem("dpa_cc"))
    this.role = JSON.parse(this.cookieData.role)
    this.isCrisis = this.cookieData.isCrisis

    $('#date').datepicker({
      //inline: true
      language: 'th-th',
    }).on('changeDate', function (e: any) {
      thisTs.util.ShowWaiting(true)
      thisTs.Search = ""
      thisTs.showingKBList = thisTs.knowledgeList.filter((kb: any) => {
        return moment(e.date).format("YYYY-MM-DD") === kb.modifiedon.substring(0, 10)
      })
      thisTs.formatAttachmentName()
      thisTs.util.ShowWaiting(false)
    });

    var TableDocs = $('#TableDocs');
    TableDocs.on('click', 'tbody tr td [role=view]', function () {
      thisTs.ViewFile($(this).attr('url'), $(this).attr('filename'));
    });

    TableDocs.on('click', 'tbody tr td [role=delete]', function () {
      thisTs.DeleteFile($(this).attr('filename'));
    });

    this.categoryList = await this.apiService.get("master", "knowledgebasecategory")

    await this.getKbList()

    
    this.AcceptExtension = environment.AcceptUploadFileExtension;
    this.MaxTotalSizeMB = environment.MaxFileSize;

    this.initialKB()
    this.util.ShowWaiting(false)
  }

  initialKB() {
    if (this.knowledgeList != null && this.knowledgeList.length > 0) {
      let i: number = 0
      while (this.knowledgeList[i] != null && i < 3) {
        this.showingKBList.push(this.knowledgeList[i])
        i++
      }
    }
    this.formatAttachmentName()
  }

  newKB(event: any) {
    this.submittedKB = false
    this.createType = ""
    this.createTitle = ""
    this.createKeyword = ""
    this.createContent = ""
    this.FileList = []
    this.CreateTableFile()
    $("#createModal").modal("show")
  }

  filterByGroup(categoryId: string) {
    this.util.ShowWaiting(true)
    this.Search = ""
    this.showingKBList = this.knowledgeList.filter((kb: any) => {
      return categoryId == kb.dpa_categoryid
    })

    this.formatAttachmentName()
    this.util.ShowWaiting(false)
  }

  filterByKeyword() {
    this.util.ShowWaiting(true)
    if (this.keyword == null || this.keyword.trim().length == 0) {
      this.Search = ""
      this.initialKB()
    }
    else {
      if (this.searchType == "k") {
        this.showingKBList = this.knowledgeList.filter((kb: any) => {
          return (kb.dpa_keyword != null && kb.dpa_keyword.toLowerCase().includes(this.keyword.toLowerCase()))
        })
      }
      else if (this.searchType == "c") {
        this.showingKBList = this.knowledgeList.filter((kb: any) => {
          return (kb.dpa_content != null && kb.dpa_content.toLowerCase().includes(this.keyword.toLowerCase()))
            || (kb.dpa_name != null && kb.dpa_name.toLowerCase().includes(this.keyword.toLowerCase()))
        })
      }
      else {//if (this.searchType == "a") {
        this.showingKBList = this.knowledgeList.filter((kb: any) => {
          return (kb.dpa_keyword != null && kb.dpa_keyword.toLowerCase().includes(this.keyword.toLowerCase()))
            || (kb.dpa_content != null && kb.dpa_content.toLowerCase().includes(this.keyword.toLowerCase()))
            || (kb.dpa_name != null && kb.dpa_name.toLowerCase().includes(this.keyword.toLowerCase()))
        })
      }
    }

    this.formatAttachmentName()
    this.Search = this.keyword
    this.util.ShowWaiting(false)
  }


  async createKB() {
    this.submittedKB = true
    if (this.createTitle != "") {
      this.util.ShowWaiting(true)
      let req: any = {
        dpa_knowledgebaseid: null,
        dpa_name: this.createTitle,
        dpa_articleno: null,
        dpa_categoryid: this.createType,
        dpa_keyword: this.createKeyword,
        dpa_content: this.createContent,
        dpa_isdisplayoncustomcrmweb: true,
        dpa_isdisplayoncustomerportal: false,
        dpa_createdby: this.cookieData.userId,
        attachfilelist: this.FileList
      }

      var res: any = await this.apiService.post("crmservice", "knowledgeBase", req);
      if (this.util.isSuccessResponse(res)) {
        await this.getKbList()
        $("#createModal").modal('hide')
        this.util.SuccessDialog("สร้าง Knowledge Base สำเร็จ")
      }
      else {
        this.util.ErrorDialog("สร้าง Knowledge Base ไม่สำเร็จ")
      }
      this.util.ShowWaiting(false)
    }
  }

  async getKbList() {
    let para = "dpa_isdisplayoncustomcrmweb=true&dpa_publishstatus=true&dpa_iscrisis=" + this.isCrisis.toString()
    this.knowledgeList = await this.apiService.get("master", "knowledgeBase", para)
  }

  formatAttachmentName() {
    this.showingKBList.forEach((k: any) => {
      if (k.attachfilelist != null && k.attachfilelist.length > 0) {
        let baseUrl = this.util.baseUrl()
        let att: any = k.attachfilelist.map((a: any) => {
          return '<a class="mr-3" target="_blank" href="' + baseUrl + '/downloadFile?file=' + a.annotationid + '">' + a.filename + "</a>"
        })
        k.dpa_attch = '<label class="mr-3">ไฟล์แนบ:</label>' + att.join("")
      }
      else {
        k.dpa_attch = ''
      }
    });
  }

  ViewFile(Url: any, FileName: any) {
    if (Url == "") {
      this.util.ErrorDialog('ไม่พบไฟล์ที่เลือก');
      return;
    }

    window.open(this.util.CreateBlobUrl(Url), "_blank");

    // $("#FileNameTitle").html(FileName);
    // $("#ViewDocFrame").attr("src", this.Util.CreateBlobUrl(Url));
    // $('#dlgFile').modal();

    // var link = document.createElement('a');
    // link.href = this.Util.CreateBlobUrl(Url);
    // link.target = "_blank";
    // link.download = FileName;
    // link.click();
    // console.log("click!");
  }

  DeleteFile(FileName: any) {
    this.FileList.forEach((item: any, index: any) => {
      if (item["filename"] === FileName)
        this.FileList.splice(index, 1);
    });
    this.CreateTableFile();
  }

  async FileSelect(File: any) {
    if (File.length == 0)
      return;
    var FileName = File[0]["name"];
    var FileExtension = FileName.substring(FileName.lastIndexOf('.') + 1, FileName.length);

    if (!this.AcceptExtension.toLowerCase().includes(FileExtension.toLowerCase())) {
      this.util.WarningDialog('รองรับเฉพาะไฟล์ ' + this.AcceptExtension);
      $('#fileAttach').val('');
      return;
    }

    var TotalFileSize: number = File[0]["size"];
    this.FileList.forEach((a: any) => {
      TotalFileSize += +a["filesize"];
    });
    if (TotalFileSize / 1024 / 1024 > this.MaxTotalSizeMB) {
      this.util.WarningDialog('ขนาดไฟล์รวมทั้งหมดต้องไม่เกิน ' + this.MaxTotalSizeMB + " MB");
      $('#fileAttach').val('');
      return;
    }

    if (this.FileList != null) {
      if (this.FileList.filter((a: any) => a.filename == File[0].name).length > 0) {
        this.util.WarningDialog("ชื่อไฟล์ซ้ำกับไฟล์ที่อัปโหลดแล้ว");
        return;
      }
    }

    var FR = new FileReader();
    var FileContent: any;
    var MimeType: any;
    let thisTs = this;
    FR.onload = (e) => {
      var t: any = e.target;
      FileContent = t.result;
      MimeType = FileContent.substring(FileContent.indexOf(":") + 1, FileContent.indexOf(";"));
      var FileContent2 = FileContent.substring(FileContent.indexOf(",") + 1, FileContent.length);

      if (thisTs.FileList == null || thisTs.FileList == undefined)
        thisTs.FileList = [];
      thisTs.FileList.push({
        "annotationid": null,
        "filename": File[0].name,
        "documentbody": FileContent2,
        "mimetype": MimeType,
        "filesize": File[0]["size"],
        "url": FileContent
      });
      $('#fileAttach').val('');
      // $('#txtFileName').val('');
      thisTs.CreateTableFile();
    };
    FR.readAsDataURL(File[0]);
    // $('#txtFileName').val(File[0]["name"]);
  }

  async UploadFile() {
    var FileInput = $('#fileAttach')[0]["files"];
    if (FileInput.length == 0) {
      this.util.ErrorDialog('กรุณาเลือกไฟล์');
      return;
    }
    if (this.FileList != null) {
      if (this.FileList.filter((a: any) => a.filename == FileInput[0].name).length > 0) {
        this.util.WarningDialog("ชื่อไฟล์ซ้ำกับไฟล์ที่อัปโหลดแล้ว");
        return;
      }
    }

    var File = new FileReader();
    var FileContent: any;
    var MimeType: any;
    let thisTs = this;
    File.onload = async (e) => {
      var t: any = e.target;
      FileContent = t.result;
      MimeType = FileContent.substring(FileContent.indexOf(":") + 1, FileContent.indexOf(";"));
      var FileContent2 = FileContent.substring(FileContent.indexOf(",") + 1, FileContent.length);

      if (thisTs.FileList == null || thisTs.FileList == undefined)
        thisTs.FileList = [];
      thisTs.FileList.push({
        "annotationid": null,
        "filename": FileInput[0].name,
        "documentbody": FileContent2,
        "mimetype": MimeType,
        "filesize": FileInput[0]["size"],
        "url": FileContent
      });
      $('#fileAttach').val('');
      $('#txtFileName').val('');

      thisTs.CreateTableFile();
    };
    File.readAsDataURL(FileInput[0]);
  }

  CreateTableFile() {
    let thisTs = this;
    var TableDocs = $('#TableDocs').DataTable({
      "paging": false,
      "bFilter": false,
      "info": false,
      "data": this.FileList,
      "columns": [
        { "data": "filename", "class": "text-center" },
        { "data": "filename" },
        {
          "data": "null",
          "render": function (data: any, type: any, row: any) {
            if (row.filesize / 1024 / 1024 < 1) {
              return Math.floor(row.filesize / 1024) + ' KB';
            }
            else {
              return (Math.round(row.filesize / 1024 / 1024 * 100 + Number.EPSILON) / 100) + ' MB';
            }
          },
          "class": "text-right"
        },
        {
          "data": null,
          "render": function (data: any, type: any, row: any) {
            return '<i class="fa fa-eye edit-icon mr-2" role="view" url="' + row.url + '" filename="' + row.filename + '" title="View"></i>' +
              '<i class="fa fa-times delete-icon ml-2" role="delete" filename="' + row.filename + '" title="Delete"></i>';
          },
          "class": "col-btn-2 text-center"
        }
      ],
      "language": {
        "zeroRecords": "ยังไม่ได้อัปโหลดไฟล์"
      }
    });

    // TableDocs.on('click', 'tbody tr td [role=view]', function () {
    //   thisTs.ViewFile($(this).attr('url'), $(this).attr('filename'));
    // });

    // TableDocs.on('click', 'tbody tr td [role=delete]', function () {
    //   thisTs.DeleteFile($(this).attr('filename'));
    // });

    TableDocs.on('order.dt search.dt', function () {
      TableDocs.column(0, { search: 'applied', order: 'applied' }).nodes().each(function (cell: any, i: any) {
        cell.innerHTML = i + 1;
      });
    }).destroy().draw();
  }

}



// WEBPACK FOOTER //
// ./src/app/knowledge-base/knowledge-base.component.ts